import { createRouter, type RouterHistory } from "@tanstack/react-router";
import { routeTree } from "./routeTree.gen";
import { queryClient } from "./lib/query-client";

/**
 * The app's router over the generated route tree, on the browser's history
 * unless one is handed in. Every unmatched path renders the root route's
 * not-found page, which draws its own frame: by default the router hands a
 * miss to the deepest matched route with children, which would draw the same
 * page bare, inside a utility's pre-auth frame or inside the signed-in frame
 * depending on the path.
 */
export function createAppRouter(history?: RouterHistory) {
  return createRouter({
    routeTree,
    history,
    context: {
      queryClient,
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion -- TanStack Router pattern: context is provided at render time via RouterProvider
      auth: undefined!,
    },
    defaultPreload: "intent",
    defaultPreloadStaleTime: 0,
    notFoundMode: "root",
  });
}

export const router = createAppRouter();

declare module "@tanstack/react-router" {
  interface Register {
    router: typeof router;
  }
}
